export enum TimeOfDay {
	All = '',
	AM = 'AM',
	PM = 'PM',
}

export const timeOfDayItems: { label: 'AM' | 'PM' | 'ALL'; value: TimeOfDay }[] = [
	{ label: 'ALL', value: TimeOfDay.All },
	{ label: 'AM', value: TimeOfDay.AM },
	{ label: 'PM', value: TimeOfDay.PM },
];

export enum DayOfWeek {
	Monday = 'Monday',
	Tuesday = 'Tuesday',
	Wednesday = 'Wednesday',
	Thursday = 'Thursday',
	Friday = 'Friday',
	Saturday = 'Saturday',
}

export const weekDaysItems: {
	label: string;
	value: DayOfWeek;
}[] = [
	{ label: DayOfWeek.Monday[0], value: DayOfWeek.Monday },
	{ label: DayOfWeek.Tuesday[0], value: DayOfWeek.Tuesday },
	{ label: DayOfWeek.Wednesday[0], value: DayOfWeek.Wednesday },
	{ label: DayOfWeek.Thursday[0] + DayOfWeek.Thursday[1], value: DayOfWeek.Thursday },
	{ label: DayOfWeek.Friday[0], value: DayOfWeek.Friday },
	{ label: DayOfWeek.Saturday[0] + DayOfWeek.Saturday[1], value: DayOfWeek.Saturday },
];
